import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _enricherLookup;
import { EnrichData } from '../types';
import EnrichVisitorId from './enrichVisitorId';
import EnrichSessionId from './enrichSessionId';
import EnrichIdToken from './enrichIdToken';
import EnrichAccessToken from './enrichAccessToken';
import EnrichExperiment from './enrichExperiment';
import EnrichUrl from './enrichUrl';
import EnrichReferralUrl from './enrichReferralUrl';
import EnrichQueryString from './enrichQueryString';
import EnrichViewProperties from './enrichViewProperties';
var enricherLookup = (_enricherLookup = {}, _defineProperty(_enricherLookup, EnrichData.CVID, 'setCheggVisitorId'), _defineProperty(_enricherLookup, EnrichData.CSID, 'setCheggSessionId'), _defineProperty(_enricherLookup, EnrichData.ID_TOKEN, 'setIdToken'), _defineProperty(_enricherLookup, EnrichData.ACCESS_TOKEN, 'setAccessToken'), _defineProperty(_enricherLookup, EnrichData.EXPERIMENT, 'setExperiments'), _defineProperty(_enricherLookup, EnrichData.URL, 'setUrl'), _defineProperty(_enricherLookup, EnrichData.REFERRAL_URL, 'setReferralUrl'), _defineProperty(_enricherLookup, EnrichData.QUERY_STRING, 'setQueryString'), _defineProperty(_enricherLookup, EnrichData.VIEW_PROPERTIES, 'setViewProperties'), _enricherLookup);
var enrichClassLookupOrder = [EnrichVisitorId, EnrichSessionId, EnrichIdToken, EnrichAccessToken, EnrichExperiment, EnrichUrl, EnrichReferralUrl, EnrichQueryString, EnrichViewProperties];

// This manager can be used to recall its functions in case of error
var EnrichmentManager = /*#__PURE__*/function () {
  function EnrichmentManager(enrichers) {
    _classCallCheck(this, EnrichmentManager);
    _defineProperty(this, "enrichers", [new EnrichVisitorId(EnrichData.CVID), new EnrichSessionId(EnrichData.CSID), new EnrichIdToken(EnrichData.ID_TOKEN), new EnrichAccessToken(EnrichData.ACCESS_TOKEN), new EnrichExperiment(EnrichData.EXPERIMENT), new EnrichUrl(EnrichData.URL), new EnrichReferralUrl(EnrichData.REFERRAL_URL), new EnrichQueryString(EnrichData.QUERY_STRING), new EnrichViewProperties(EnrichData.VIEW_PROPERTIES)]);
    if (enrichers) {
      this.enrichers = enrichers;
    } else {
      this.performEnrichment();
    }
  }

  // update latest enrichment on calling this, no matter how many times its called it will not consume extra space.
  _createClass(EnrichmentManager, [{
    key: "performEnrichment",
    value: function performEnrichment() {
      this.enrichers.forEach(function (enricher) {
        enricher.update();
      });
    }

    // apply all enrichments to any event
  }, {
    key: "applyEnrichers",
    value: function applyEnrichers(event) {
      this.enrichers.forEach(function (enricher) {
        var propertyName = enricherLookup[enricher.name];
        if (propertyName) {
          event[propertyName](enricher.getEnrichValue());
        }
      });
    }
  }, {
    key: "getRawEnrichers",
    value: function getRawEnrichers() {
      return this.enrichers.map(function (enricher) {
        return {
          name: enricher.name,
          value: enricher.value
        };
      });
    }
  }, {
    key: "updateEnrichersFromRaw",
    value: function updateEnrichersFromRaw(rawEnrichers) {
      var enrichers = enrichClassLookupOrder.map(function (Classtype, index) {
        var enricher = new Classtype(rawEnrichers[index].name, rawEnrichers[index].value);
        return enricher;
      });
      this.enrichers = enrichers;
    }
  }, {
    key: "setViewProperties",
    value: function setViewProperties(updatedCurrentView) {
      // extracting ViewProperties enricher
      this.enrichers.slice(-1)[0].update(updatedCurrentView);
    }
  }]);
  return EnrichmentManager;
}();
export { EnrichmentManager as default };